import { Component, input } from '@angular/core';

import { StreamingEntry } from './vb-lxp-admin-settings.service';

@Component({
  selector: 'vb-lxp-streaming-table',
  standalone: true,
  templateUrl: './vb-lxp-streaming-table.component.html',
  styleUrls: ['./vb-lxp-streaming-table.component.css'],
})
export class VbLxpStreamingTableComponent {
  readonly rows = input.required<StreamingEntry[]>();
}
